
export function processContactData( communityData, salesCounselorData ) {
  if ( !communityData || !salesCounselorData ) {
    return;
  }

  const email = salesCounselorData?.mail
    || communityData?.email;
  const phone = salesCounselorData?.fieldPhone
    || communityData?.phone;
  const name = salesCounselorData?.fieldFirstName || 'us';

  return {
    email,
    phone,
    name,
  }
}